import { createAsyncThunk } from '@reduxjs/toolkit';
import { checkSecureData } from 'services/secureDataSharing';
import { ICheckSecureDataPayload } from 'services/secureDataSharing/types';
import { ICommonResponse } from 'services/types';

export const ThunkCheckSecureData = createAsyncThunk<
  ICommonResponse<boolean>,
  ICheckSecureDataPayload
>('secureDataSharing/checkSecureData', payload => checkSecureData(payload).then(r => r.data));
